import React, { useEffect, useState, useContext, useRef } from 'react';
import { Modal, Table, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import './Styles.css';

function SolarYielding({ SN, Combinations }) {
    const { t } = useTranslation();


    const handleClick = () => {
        Modal.info({
            maskClosable: true,
            width: "70%",
            icon: null,
            title: t("Solar Yielding"),
            content: (<Table 
                pagination={false}
                columns={[
                    { title: t("Inverter SN"), dataIndex: "SN",  align: "right",render: (v,r) => {
                        return `${v}${r.Phase == 2 ? "(A)" : r.Phase == 3 ? "(B)" : r.Phase == 4 ? "(C)" : ""}`;
                    } },
                    { title: t("DataTime"), dataIndex: "CreateTime",  align: "right" },
                    { title: t("Daily PV Energy (kWh)"), dataIndex: "EDayPV",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Monthly PV Energy (kWh)"), dataIndex: "EMonthPV",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Yearly PV Energy (kWh)"), dataIndex: "EYearPV",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Total PV Energy (kWh)"), dataIndex: "ETotalPV",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Daily PV Inverter Energy (kWh)"), dataIndex: "EDayPVInverter",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Monthly PV Inverter Energy (kWh)"), dataIndex: "EMonthPVInverter",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Yearly PV Inverter Energy (kWh)"), dataIndex: "EYearPVInverter",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                    { title: t("Total PV Inverter Energy (kWh)"), dataIndex: "ETotalPVInverter",  align: "left", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        v = parseInt(v);
                        if (v > 0x7fffffff) {
                            v = v - 0x100000000;
                        }
                        return (v * 0.01).toFixed(2);
                    }},
                ]}
                summary={(data) => {
                    if (!data || data.length < 2) {
                        return null;
                    }
                    let EDayPV = 0;
                    let EMonthPV = 0;
                    let EYearPV = 0;
                    let ETotalPV = 0;
                    let EDayPVInverter = 0;
                    let EMonthPVInverter = 0;
                    let EYearPVInverter = 0;
                    let ETotalPVInverter = 0;
                    data.forEach((item, index) => {
                        if (item.EDayPV != null ) {
                            let v = parseInt(item.EDayPV);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EDayPV += v * 0.01;
                        }
                        if (item.EMonthPV != null ) {
                            let v = parseInt(item.EMonthPV);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EMonthPV += v * 0.01;
                        }
                        if (item.EYearPV != null ) {
                            let v = parseInt(item.EYearPV);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EYearPV += v * 0.01;
                        }
                        if (item.ETotalPV != null ) {
                            let v = parseInt(item.ETotalPV);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            ETotalPV += v * 0.01;
                        }
                        if (item.EDayPVInverter != null ) {
                            let v = parseInt(item.EDayPVInverter);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EDayPVInverter += v * 0.01;
                        }
                        if (item.EMonthPVInverter != null ) {
                            let v = parseInt(item.EMonthPVInverter);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EMonthPVInverter += v * 0.01;
                        }
                        if (item.EYearPVInverter != null ) {
                            let v = parseInt(item.EYearPVInverter);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            EYearPVInverter += v * 0.01;
                        }
                        if (item.ETotalPVInverter != null ) {
                            let v = parseInt(item.ETotalPVInverter);
                            if (v > 0x7fffffff) {
                                v = v - 0x100000000;
                            }
                            ETotalPVInverter += v * 0.01;
                        }
                    });
                    return (
                        <>
                            <Table.Summary.Row style={{fontWeight:"bold"}}>
                                <Table.Summary.Cell index={0} colSpan={2} align='right'>{t("Subtotal")}</Table.Summary.Cell>
                                <Table.Summary.Cell index={1}>{EDayPV.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={2}>{EMonthPV.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={3}>{EYearPV.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={4}>{ETotalPV.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={5}>{EDayPVInverter.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={6}>{EMonthPVInverter.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={7}>{EYearPVInverter.toFixed(2)}</Table.Summary.Cell>
                                <Table.Summary.Cell index={8}>{ETotalPVInverter.toFixed(2)}</Table.Summary.Cell>
                            </Table.Summary.Row>
                        </>
                    );
                }}
                dataSource={Combinations}
                scroll={{ x: true }}
            />),
            onOk() {
            },
        });
    };

    let EDayPV = 0;
    let ETotalPV = 0;
    let EDayPVInverter = 0;
    let ETotalPVInverter = 0;
    let count = Combinations?.length || 0;

    if (Combinations != null) {
        Combinations.forEach((item, index) => {
            if (item.EDayPV != null ) {
                let v = parseInt(item.EDayPV);
                if (v > 0x7fffffff) {
                    v = v - 0x100000000;
                }
                EDayPV += v * 0.01;
            }
            if (item.ETotalPV != null ) {
                let v = parseInt(item.ETotalPV);
                if (v > 0x7fffffff) {
                    v = v - 0x100000000;
                }
                ETotalPV += v * 0.01;
            }
            if (item.EDayPVInverter != null ) {
                let v = parseInt(item.EDayPVInverter);
                if (v > 0x7fffffff) {
                    v = v - 0x100000000;
                }
                EDayPVInverter += v * 0.01;
            }
            if (item.ETotalPVInverter != null ) {
                let v = parseInt(item.ETotalPVInverter);
                if (v > 0x7fffffff) {
                    v = v - 0x100000000;
                }
                ETotalPVInverter += v * 0.01;
            }
        });
    }
    

    return (<div className="combination-stats-block" >
        <div className="title" style={{ backgroundColor: '#82b2c7' }}>
            {t('Solar Yielding')}
            <Button ghost size='small' shape="round" onClick={handleClick}>{t("Details")}</Button>
        </div>
        <div className="content" >
            <div className="left">
                <img src="images/inverter/solar.png" alt={t('Solar')}></img>
            </div>
            <div className="right">
                <div style={{ fontSize: '18px', display:"flex",justifyContent:"flex-end",alignItems:"flex-start"}}>
                    {EDayPV.toFixed(2)} {t('kWh')}
                    {count>1 && <span className='sigma'>(Σ{count})</span>}
                </div>
                <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Today Yielding')}</div>
                <div style={{ fontSize: '18px', display:"flex",justifyContent:"flex-end",alignItems:"flex-start"}}>
                    {ETotalPV.toFixed(2)} {t('kWh')}
                    {count>1 && <span className='sigma'>(Σ{count})</span>}
                </div>
                <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Total Yielding')}</div>
            </div>
        </div>
    </div>);
}

export default SolarYielding;